import React from "react";
import Alert from "@carrier-io/air-react/Alert";
import AlertTitle from "@carrier-io/air-react/AlertTitle";
import { AlertProps } from "../types";

export const ErrorAlert = ({ message, onClose }: AlertProps) => {
  return (
    <Alert
      data-testid="error-alert"
      closeText="Close"
      onClose={onClose}
      role="alert"
      color="error"
      severity="error"
      variant="standard"
    >
      <AlertTitle>Error</AlertTitle>
      {message}
    </Alert>
  );
};
